import { useEffect, useState } from 'react'
import get from 'lodash/get'

const CONFIG_API_GEOLOCATION = 'https://superwallet-misc.coin98.tech/geolocations'

export const useGeoCheck = () => {
  const [isRestricted, setIsRestricted] = useState(false)
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    let isMounted = true

    const checkGeo = async () => {
      try {
        const res = await fetch(CONFIG_API_GEOLOCATION)
        const json = await res.json()
        const countryCode = get(json, 'data.countryCode', '').toUpperCase()
        if (isMounted && countryCode === 'VN') {
          setIsRestricted(true)
        }
      } catch (err) {
        console.error('Failed to check geolocations:', err)
      } finally {
        if (isMounted) {
          setIsChecking(false)
        }
      }
    }

    checkGeo()

    return () => {
      isMounted = false
    }
  }, [])

  return { isRestricted, isChecking }
}
